export default __webpack_public_path__ + "static/media/departments.33de3dfb.jpg";